import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=de42b522&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de42b522",
  null
  
)

export default component.exports